module.exports = __webpack_public_path__ + "img/example_3_icon.25518836.png";